import type { Category } from '@inmotion/models';

/** A root category's children are keyed under `null`, regardless of whether its
 * `parentCategoryId` is `null` or `undefined` on the source data. */
export default function groupCategoriesByParentId(
  categories: Array<Category>,
): Map<string | null, Array<Category>> {
  const childrenByParentId = new Map<string | null, Array<Category>>();

  categories.forEach((category) => {
    const parentId = category.parentCategoryId ?? null;
    const siblings = childrenByParentId.get(parentId);
    if (siblings) siblings.push(category);
    else childrenByParentId.set(parentId, [category]);
  });

  return childrenByParentId;
}
